import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useOrganizations } from "@/hooks/useOrganizations";
import OrganizationsTable from "./OrganizationsTable";
import OrganizationFormModal from "./OrganizationFormModal";
import { Organization } from "@/hooks/useOrganizations";
import AdminPageHeader from '@/components/v2/atoms/admin/layout/AdminPageHeader';

const OrganizationsTab = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingOrganization, setEditingOrganization] = useState<Organization | null>(null);
  const { data: organizations, isLoading } = useOrganizations();

  const handleEdit = (organization: Organization) => {
    setEditingOrganization(organization);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setEditingOrganization(null);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <h2 className="text-2xl font-bold">Organizaciones</h2>
          <p className="text-muted-foreground">
            Gestiona las organizaciones para clasificar propiedades y contratos
          </p>
        </div>
        <Button onClick={() => setIsModalOpen(true)}>
          <Plus className="mr-2 h-4 w-4" />
          Nueva Organización
        </Button>
      </div>

      <OrganizationsTable 
        organizations={organizations || []} 
        isLoading={isLoading} 
        onEdit={handleEdit}
      />

      <OrganizationFormModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        organization={editingOrganization}
      />
    </div>
  );
};

export default OrganizationsTab;
